
import React, { useEffect, useState } from "react";
import { Navbar, Nav, Offcanvas, Button, Collapse, OverlayTrigger, Tooltip, Col, Container, Row, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../../assets/css/sidebar.css"
import Template from "../../../layout/Template";
import { useLocation, useParams } from "react-router-dom";
import ProfissionalEdit from "./ProfissionalEdit";
import ProfissionaisAgendaConfig from "./ProfissionaisAgendaConfig";

export default function ProfissionaisMenuLateral({ children, profissional, contentSel }) {
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [showMobile, setShowMobile] = useState(false);
    const [openUsuarios, setOpenUsuarios] = useState(false);
    const [openConfig, setOpenConfig] = useState(false);

    const toggleSidebar = () => setSidebarOpen(!sidebarOpen);

    const [contentMenu, setContentMenu] = useState(contentSel)
    const [contentSubMenu, setSubContentMenu] = useState()

    const location = useLocation();
    const currentPath = location.pathname;


    const handleSelectOpcao = (e) => {
        setContentMenu(e.target.value)
    }

    useEffect(() => {
        console.log(contentSel)
        if (contentSel != undefined) {
            setContentMenu(contentSel)
        }

        let path = currentPath.split('/')
        /* setContentMenu(path[2])
         setSubContentMenu(path[2])
         switch (path[2]) {
             case 'usuarios':
             case 'gruposUsuarios':
                 setContentMenu('usuarios')
                 setOpenUsuarios(true)
 
                 break;
         }
         if (path[3] != undefined) {
             setSubContentMenu(path[3])
         }*/
        //console.log(path)

    }, [])

    const menuItems = [
        {
            icon: "",
            label: "Dados",
            link: "#",
            content: "edit"
        }, {
            icon: "",
            label: "Configuração de Agenda",
            link: "#",
            content: "agenda",
        },


        /*   {
               icon: "⚙",
               label: "Configurações",
               submenu: [
                   { label: "Usuários", link: "#usuarios" },
                   { label: "Permissões", link: "#permissoes" },
               ],
               open: openConfig,
               toggle: () => setOpenConfig(!openConfig),
           },
           {
               icon: "📊",
               label: "Relatórios",
               link: "#relatorios",
           },*/
    ];

    const carregaConteudo = () => {
        return
    }

    return (




        <div className="d-flex" id="container-interno">
            {/* Sidebar desktop */}
            <div id="sidebar"
                className="d-none d-lg-flex flex-column"
                style={{
                    width: sidebarOpen ? "220px" : "70px",
                    minHeight: "100vh",
                    transition: "width 0.3s ease",
                    overflowX: "hidden",
                }}
            >
                {/* Botão de toggle */}
                <div className="p-2 border-bottom border-secondary">
                    <h5 className="text-primary text-center">Profissional</h5>
                    {/*<Button variant="link" className="text-white" onClick={toggleSidebar}>
                        {sidebarOpen ? "⬅" : "➡"}
                    </Button>*/}
                </div>

                <Nav className="flex-column" >
                    {menuItems.map((item, idx) => (
                        <div key={idx}>
                            {item.submenu ? (
                                <>
                                    <OverlayTrigger
                                        placement="right"
                                        overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                    >
                                        <Button
                                            className={(contentMenu == item.content) ? 'selected  text-start w-100' : ' text-start w-100'}
                                            variant="link"
                                            onClick={item.toggle}
                                        >
                                            {item.icon} {sidebarOpen && item.label}
                                        </Button>
                                    </OverlayTrigger>

                                    <Collapse in={item.open} style={{ 'marginTop': '6px' }}>
                                        <div className="ps-4">
                                            {item.submenu.map((sub, sIdx) => (
                                                <Nav.Link key={sIdx} href={sub.link}
                                                    className={(contentSubMenu == sub.content) ? 'selected  text-white-50' : ' text-white-50'}
                                                    onClick={() => setContentMenu(sub.content)}>
                                                    {sidebarOpen && sub.label}
                                                </Nav.Link>
                                            ))}
                                        </div>
                                    </Collapse>
                                </>
                            ) : (
                                <OverlayTrigger
                                    placement="right"
                                    overlay={!sidebarOpen ? <Tooltip>{item.label}</Tooltip> : <></>}
                                >
                                    <Nav.Link href={item.link} className={(contentMenu == item.content) ? 'selected' : ''} onClick={() => setContentMenu(item.content)}>
                                        {item.icon} {sidebarOpen && item.label}
                                    </Nav.Link>
                                </OverlayTrigger>
                            )}
                        </div>
                    ))}
                </Nav>
            </div>

            {/* Navbar Mobile 
            <Navbar bg="" variant="" expand={false} className="d-lg-none w-100">
                <Button variant="info" onClick={() => setShowMobile(true)}>
                    ☰ Menu
                </Button>
            </Navbar>*/}


            {/* Offcanvas Mobile */}
            <Offcanvas show={showMobile} onHide={() => setShowMobile(false)} id="menu-mobile">
                <Offcanvas.Header closeButton closeVariant="white">
                    <Offcanvas.Title>Menu</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="flex-column">
                        {menuItems.map((item, idx) => (
                            <div key={idx}>
                                {item.submenu ? (
                                    <>
                                        <Button
                                            variant="link"
                                            className="text-white text-start w-100"
                                            onClick={item.toggle}
                                        >
                                            {item.icon} {item.label}
                                        </Button>
                                        <Collapse in={item.open}>
                                            <div className="ps-4">
                                                {item.submenu.map((sub, sIdx) => (
                                                    <Nav.Link key={sIdx} href={sub.link} className="text-white-50" onClick={() => { setContentMenu(sub.content); setShowMobile(false) }}>
                                                        {sub.label}
                                                    </Nav.Link>
                                                ))}
                                            </div>
                                        </Collapse>
                                    </>
                                ) : (
                                    <Nav.Link href={item.link} className="text-white" onClick={() => { setContentMenu(item.content); setShowMobile(false) }}>
                                        {item.icon} {item.label}
                                    </Nav.Link>
                                )}
                            </div>
                        ))}
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>



            {/* Conteúdo principal */}
            <div className="flex-grow-1 " style={{ padding: '0px 0px 10px' }}>
                {<Container fluid id="cliente-header">
                      <h5>Profissionais</h5>
                    <div className="alert alert-secondary">Você está visualizando a ficha de <span className="bold">{profissional?.nome}</span></div>
                </Container>}

                <div className="d-lg-none w-100 box-fundo mb-15">
                  
                    <label className="mb-10">  Selecione a opção:</label>
                    <select className="form-control form-select" onChange={(e) => handleSelectOpcao(e)}>

                        {menuItems?.map((item) => (
                            <option value={item.content}>{item.label}</option>
                        ))}
                    </select>
                </div>

                <div id="divContent-sidebar" className="">
                    {console.log(contentMenu)}
                    {(contentMenu == 'edit') ? <ProfissionalEdit idProfissional={profissional?.id} /> : ''}
                    {(contentMenu == 'agenda') ? <ProfissionaisAgendaConfig idProfissional={profissional?.id} /> : ''}
                </div>

            </div>
        </div>
    );
}
